<div class="fixed-top menu">
    <!--<compliance-menu [menus]="menus" [uploadStatus]="true"></compliance-menu>-->
    <compliance-header [menus]="menus" [uploadStatus]="true" [typeContent]="'project'"></compliance-header>
</div>
<div class="compliance-app  mt-0 height-100">
    <router-outlet></router-outlet>
</div>
